import styled from 'styled-components'

import { ToggleContainer } from './styles'

export const ToggleWithExpandableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ExpandableToggleContainer = styled(ToggleContainer)<{
  $isExpanded: boolean
}>`
  border-radius: ${({ $isExpanded }) => ($isExpanded ? '8px 8px 0 0' : '8px')};
  transition: border-radius 0.25s cubic-bezier(0.4, 0, 0.2, 1);
`

export const ExpandableContent = styled.div<{
  $isExpanded: boolean
  $disabled?: boolean
}>`
  background-color: ${({ theme, $disabled }) =>
    $disabled ? 'transparent' : theme.colors.white};
  border-radius: 0 0 8px 8px;
  border: ${({ $disabled, $isExpanded, theme }) =>
    $disabled && $isExpanded ? `1px solid ${theme.colors.crystalBay}` : 'none'};
  border-top: none;
  overflow: hidden;
  display: grid;
  grid-template-rows: ${({ $isExpanded }) => ($isExpanded ? '1fr' : '0fr')};
  transition:
    grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    margin-top 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: ${({ $isExpanded }) => ($isExpanded ? '-8px' : '0')};
`

export const ExpandableContentInner = styled.div<{ $isExpanded: boolean }>`
  overflow: hidden;
  padding: ${({ $isExpanded }) => ($isExpanded ? '16px 20px' : '0 20px')};
  transition: padding 0.35s cubic-bezier(0.4, 0, 0.2, 1);
`
